export var colors = {
    blueShades: {
        9: '#0D9489',
        10: "#1976E7",
        11: "#00375C",
        12: "#1F275C",
    },
    greyShades: {
        10: "#9E9E9E",
        11: "#F7F7F7",
        12: "#DADADA",
        13: "#4F4F4F",
        14: "#F5F5F5",
        15: "#848484",
        16: "#A6A6A6",
        17: "#F3F5F4",
        18: '#A3A9B9',
        19: '#F5F5F5',
        20: '#E2E7EB',
        21: '#F9F9F9',
    },
    yellowShades: {
        10: "#856404",
        11: "#D0A733"
    },
    purpleShades: {
        10: "#DFCCFCCC",
    },
    errorShades: {
        10: "#AC1111",
    },
    creamPreset: {
        10: '#F9F4E6',
        20: '#EDDDB0',
        30: '#F8D5BA',
        40: '',
        50: '',
        60: '',
    },
    fullWhite: '#FFFFFF',
};
export var baseColors = {
    fullWhite: '#FFFFFF',
    fullBlack: '#000000',
    greyPreset: {
        5: '#6F6F6D',
        10: '#3C3C3B',
        20: '#B7B7B5',
        30: '#979796',
        40: '#DADAD9',
        45: '#EFEFEF',
        50: '#F7F7F7',
        55: '#F3F3F1',
        60: '#EAEAE9',
        70: '',
        80: '',
        90: '',
        100: '',
    },
    warningPreset: {
        10: '#DDBF17',
        20: '#D98F00',
        30: '#F5F0BC',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
    },
    errorPreset: {
        10: '#FD4217',
        20: '#C92000',
        30: '#FFCABA',
        40: '#FFA78E',
    },
    successPreset: {
        10: '#0A776C',
        20: '#F2F4FA',
        30: '#0D9489',
        40: '#2AA31F',
        50: '#006100',
        60: '#C6E7C1',
        70: '#A0D899',
        80: '#199111',
    },
    bluePreset: {
        10: '#20285C',
        20: '#C0DDFF',
        30: '#4C82EF',
        40: '#314158',
        50: '#455EC7',
        60: '#BEE1FF',
        70: '#72B2FF',
        80: '#2B7FFF',
        90: '#4D90FE',
        100: '#4870DA'
    },
    darkPreset: {
        10: "#1C1C1B",
    },
};
